/**
 * Base css generation and global js logic.
 */

import 'tokens/sass/tokens.scss';

import { MaskInput } from 'maska';

new MaskInput('[data-maska]', {
  tokens: {
    '*': {
      pattern: /[a-zA-Z0-9]/,
      transform: (chr) => chr.toUpperCase(),
    },
  },
});

// Export global variables.
export default {};
